import * as React from 'react';
import { SVGProps } from 'react';
const IcHigh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <rect width={24} height={24} x={0.667} fill="#FFE8D2" rx={12} />
    <path
      fill="#9E520A"
      d="m13.64 5.361 6.476 11.215a1.124 1.124 0 0 1-.974 1.688H6.192a1.125 1.125 0 0 1-.975-1.688l6.475-11.215a1.125 1.125 0 0 1 1.949 0Zm-.973 8.889a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0-5.25a.75.75 0 0 0-.745.662l-.005.088v3a.75.75 0 0 0 1.494.088l.006-.088v-3a.75.75 0 0 0-.75-.75Z"
    />
  </svg>
);

export default IcHigh;
